import { createReducer, on } from '@ngrx/store';
import { AppState } from '../../app.reducer';
import { setCart, unSetCart, getCart } from './cart.actions';

export interface State {
    info: any;
}

export interface AppStateCart extends AppState {
    info: State
}

export const initialState: State = {
    info: null
};

const _cartReducer = createReducer(initialState,
    on(setCart, (state, { info }) => ({ ...state, info })),
    on(unSetCart, state => ({ ...state, info: null })),
    on(getCart, (state) => ({ ...state, }))
);

export function cartReducer(state: any, action: any) {
    return _cartReducer(state, action);
}
